module.exports = __webpack_public_path__ + "static/media/YF61_0.b5083e67.jpg";